<div *ngIf="!loading" class="container-comprobante">
    <app-voucher [voucherProperties]="voucherProperties" 
                 [goBackFunction]="goToHome" 
                 [solicitudResponse]="solicitudResponse">
    </app-voucher>
</div>

<div *ngIf="loading" class="container-comprobante">
    <ion-skeleton-text
        animated
        style="width: 100%; height: 30px; border-radius: 12px"
      ></ion-skeleton-text>
      <ion-skeleton-text
        animated
        style="width: 100%; height: 30px; border-radius: 12px"
      ></ion-skeleton-text>
      <ion-skeleton-text
        animated
        style="width: 100%; height: 30px; border-radius: 12px"
      ></ion-skeleton-text>
      <ion-skeleton-text
        animated
        style="width: 100%; height: 30px; border-radius: 12px"
      ></ion-skeleton-text>
</div>